import { FC, useEffect, useRef } from "react";
import { Flex, Box } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import Menu from "../Menu/Menu";
import HeaderComponent from "../../molecule/Header/HeaderComponent";
import { useScroll } from "../../../provider/ScrollProvider";

const GeneralLayout: FC = () => {
  const scrollBoxRef = useRef<HTMLDivElement>(null);
  const { setScrollRef } = useScroll();

  useEffect(() => {
    setScrollRef(scrollBoxRef);
  }, [setScrollRef]);

  return (
    <Flex as="main" width="100vw" height="100vh" overflow="hidden">
      <Flex
        color="#fff"
        overflowY="auto"
        bgGradient="linear(130deg, #062952 70%, #26615E 100%)"
        py={10}
        px={8}
        zIndex="1"
      >
        <Menu />
      </Flex>

      <Box
        ref={scrollBoxRef}
        flex="1"
        w="100%"
        bgColor="white"
        py={16}
        px={14}
        position="relative"
        overflowY="auto"
      >
        <HeaderComponent />
        <Outlet />
      </Box>
    </Flex>
  );
};

export default GeneralLayout;
